import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
}

export function formatDate(dateStr: string): string {
  return format(new Date(dateStr), 'dd/MM/yyyy HH:mm', { locale: es });
}

export function formatDimension(meters: number): string {
  return `${meters.toFixed(2)} m`;
}

export function formatArea(m2: number): string {
  return `${m2.toFixed(2)} m²`;
}

/** Resuelve la URL de una imagen de producto.
 *  - Si ya es una URL completa (Cloudinary), la devuelve tal cual.
 *  - Si es una ruta local legacy, antepone /uploads/.
 */
export function resolveImageUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  return path.startsWith('http') ? path : `/uploads/${path}`;
}
